import React from 'react';
import Modal from 'react-responsive-modal';
import 'react-responsive-modal/lib/react-responsive-modal.css';

import LanguageStringResolver from '../../fields/language/LanguageStringResolver';
import Logger, {LOG_LEVELS} from '../../../utils/logger';

const log = new Logger('MANUAL_DOCUMENTS_MODAL_FORM', LOG_LEVELS.DEBUG);

const MODAL_CLASSNAMES =  {
    modal: 'modal-full-width-height modal-max-width-65'
};

class ManualDocumentsModal extends React.Component {

    render() {
        log.debug('render(): ', this.props);
        
        return (
            <div>
                <Modal 
                    classNames={MODAL_CLASSNAMES}                    
                    open={this.props.open} 
                    onClose={this.props.onClose} 
                    closeOnEsc={true} 
                    blockScroll={true}
                    closeOnOverlayClick={false} 
                    center 
                >
                    <h2>{this.props.title ? this.props.title : (<LanguageStringResolver string='manualDocumentsModal_defaultTitle'/>)}</h2>
                    <div>
                        {this.props.children}
                    </div>
                </Modal>  
            </div>
        );
    }
}


ManualDocumentsModal.defaultProps = {
    onClose: () => {},
    onSubmit: () => {}
};

export default ManualDocumentsModal;